// extracted by mini-css-extract-plugin
export default {"container":"BlogList_container__S5-sy","cardContainer":"BlogList_cardContainer__b3LdJ"};